import { Grid } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { IconProps } from "@material-ui/core/Icon";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React from "react";
// import { FormattedMessage } from "react-intl";

const useStyles = makeStyles(
  theme => ({
    cardContent: {
      "&:last-child": {
        padding: theme.spacing(2, 3)
      },
      display: "flex",
      gridColumnGap: theme.spacing(3),
      gridTemplateColumns: "1fr 64px",
      justifyContent: "space-between",
      alignItems: "center"
    },
    // cardItem: {
    //   height: "40px",
    //   justifyContent: "space-between",
    //   alignItems: "center"
    // },
    cardSpacing: {
      [theme.breakpoints.down("sm")]: {
        marginBottom: theme.spacing(1)
      },
      marginBottom: theme.spacing(3)
    },
    cardSubtitle: {
      fontSize: 13,
      height: "20px",
      lineHeight: 0.9,
      textAlign: "center"
    },
    todayFontSize: {
      fontWeight: "bold"
    },
    cardTitle: {
      fontSize: 20,
      fontWeight: 500 as 500
    },
    icon: {
      color: theme.palette.primary.contrastText,
      fontSize: 54,
      margin: ".5rem .3rem"
    },
    iconBackground: {
      backgroundColor: theme.palette.background.default,
      borderRadius: "8px",
      color: "white",
      fontSize: "54px",
      height: "100%",
      padding: "10px 5px 0px 5px",
      width: "70px"
    },
    value: {
      textAlign: "right"
    }
  }),
  { name: "HomeAnalyticsCard" }
);

interface HomeAnalyticsCardProps {
  icon: React.ReactElement<IconProps>;
  title: string;
  titleSpan: string;
  children?: React.ReactNode;
  sales: any;
  salesyesterday: any;
  titleSpan1: string;
  leftTitle1: string;
  leftTitle2: string;
  ordersyesterday: any;
  orderstoday: any;
  PaymentRatio1?: any;
  PaymentRatio2?: any;
}

const HomeAnalyticsCard: React.FC<HomeAnalyticsCardProps> = props => {
  const {
    title,
    titleSpan,
    icon,
    sales,
    salesyesterday,
    titleSpan1,
    leftTitle1,
    leftTitle2,
    orderstoday,
    ordersyesterday,
    PaymentRatio1,
    PaymentRatio2
  } = props;

  const classes = useStyles(props);

  return (
    <Card className={classes.cardSpacing}>
      <CardContent className={classes.cardContent}>
        <Grid container direction="column">
          <Typography className={classes.cardTitle} variant="subtitle1">
            {title}
          </Typography>

          <Grid container justify="space-between">
            <Grid item xs={4}>
              <Typography
                className={classes.cardSubtitle}
                variant="caption"
                color="textSecondary"
              >
                {/* <FormattedMessage
                  // defaultMessage={titleSpan ? titleSpan : " "}
                  defaultMessage={" "}
                  id="homeAnalyticsCardHeader"
                /> */}
                <div id="homeAnalyticsCardHeader" />
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                className={classes.cardSubtitle}
                variant="caption"
                color="textSecondary"
              >
                {/* <FormattedMessage
                  // defaultMessage={titleSpan ? titleSpan : " "}
                  defaultMessage={titleSpan}
                  id="homeAnalyticsCardHeader"
                /> */}
                <div>{titleSpan}</div>
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                className={classes.cardSubtitle}
                variant="caption"
                color="textSecondary"
              >
                {/* <FormattedMessage
                  // defaultMessage={titleSpan ? titleSpan : " "}
                  defaultMessage={titleSpan1}
                  id="homeAnalyticsCardHeader"
                /> */}
                <div>{titleSpan1}</div>
              </Typography>
            </Grid>
          </Grid>
          <Grid container justify="space-between">
            <Grid item xs={4}>
              <Typography
                className={classes.cardSubtitle}
                variant="caption"
                color="textSecondary"
              >
                {/* <FormattedMessage
                  // defaultMessage={titleSpan ? titleSpan : " "}
                  defaultMessage={leftTitle1}
                  id="homeAnalyticsCardHeader"
                /> */}
                <div id="homeAnalyticsCardHeader"> {leftTitle1}</div>
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                className={`${classes.cardSubtitle} ${classes.todayFontSize}`}
                variant="caption"
                color="textSecondary"
              >
                {/* <FormattedMessage
                  // defaultMessage={titleSpan ? titleSpan : " "}
                  defaultMessage={sales || sales === 0 ? sales : "0.00"}
                  id="homeAnalyticsCardHeader"
                /> */}
                <div>{sales || sales === 0 ? sales : "0.00"}</div>
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                className={classes.cardSubtitle}
                variant="caption"
                color="textSecondary"
              >
                {/* <FormattedMessage
                  // defaultMessage={titleSpan ? titleSpan : " "}
                  defaultMessage={
                    salesyesterday || salesyesterday === 0
                      ? salesyesterday
                      : "0.00"
                  }
                  id="homeAnalyticsCardHeader"
                /> */}
                <div>
                  {salesyesterday || salesyesterday === 0
                    ? salesyesterday
                    : "0.00"}
                </div>
              </Typography>
            </Grid>
          </Grid>
          <Grid container justify="space-between">
            <Grid item xs={4}>
              <Typography
                className={classes.cardSubtitle}
                variant="caption"
                color="textSecondary"
              >
                {/* <FormattedMessage
                  // defaultMessage={title=="Orders"?"POT":' '}
                  defaultMessage={leftTitle2}
                  id="homeAnalyticsCardHeader"
                /> */}
                <div>{leftTitle2}</div>
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                className={classes.cardSubtitle}
                variant="caption"
                color="textSecondary"
              >
                {/* <FormattedMessage
                  // defaultMessage={titleSpan ? titleSpan : " "}
                  defaultMessage={
                    orderstoday || orderstoday === 0 ? orderstoday : " "
                  }
                  id="homeAnalyticsCardHeader"
                /> */}
                <div>{orderstoday}</div>
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                className={classes.cardSubtitle}
                variant="caption"
                color="textSecondary"
              >
                {/* <FormattedMessage
                  // defaultMessage={titleSpan ? titleSpan : " "}
                  defaultMessage={
                    ordersyesterday || ordersyesterday === 0
                      ? ordersyesterday
                      : " "
                  }
                  id="homeAnalyticsCardHeader"
                /> */}
                <div>
                  {ordersyesterday || ordersyesterday === 0
                    ? ordersyesterday
                    : " "}
                </div>
              </Typography>
            </Grid>
          </Grid>
          <Grid container justify="space-between">
            <Grid item xs={4}>
              <Typography
                className={classes.cardSubtitle}
                variant="caption"
                color="textSecondary"
              >
                {/* <FormattedMessage
                  // defaultMessage={titleSpan ? titleSpan : " "}
                  defaultMessage={title === "Orders" ? "Payment Ratio" : " "}
                  id="homeAnalyticsCardHeader"
                /> */}
                <div>{title === "Orders" ? "Payment Ratio" : " "}</div>
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                className={classes.cardSubtitle}
                variant="caption"
                color="textSecondary"
              >
                {/* <FormattedMessage
                  // defaultMessage={titleSpan ? titleSpan : " "}
                  defaultMessage={title === "Orders" ? PaymentRatio1 : " "}
                  id="homeAnalyticsCardHeader"
                /> */}
                <div>{title === "Orders" ? PaymentRatio1 : " "}</div>
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                className={classes.cardSubtitle}
                variant="caption"
                color="textSecondary"
              >
                {/* <FormattedMessage
                  // defaultMessage={titleSpan ? titleSpan : " "}
                  defaultMessage={title === "Orders" ? PaymentRatio2 : " "}
                  id="homeAnalyticsCardHeader"
                /> */}
                <div>{title === "Orders" ? PaymentRatio2 : " "}</div>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {/* <Typography className={classes.value} color="textPrimary" variant="h4">
            {children && children[0]}
          </Typography> */}
        <div className={classes.iconBackground}>{icon}</div>
      </CardContent>
    </Card>
  );
};
HomeAnalyticsCard.displayName = "HomeAnalyticsCard";
export default HomeAnalyticsCard;
